var Model = require('../model/PanoModel');

module.exports = Backbone.Collection.extend({
        
    model: Model,

	sort_key: 'order'

});